module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"update-webhook":"Update Webhook Subscription","webhook-updated":"Webhook Subscription updated","failed-update-webhook":"Failed to update webhook subscription","create-webhook":"Create Webhook Subscription","webhook-created":"Webhook Subscription created","failed-create-webhook":"Failed to create webhook subscription"}}')
  delete Component.options._Ctor
}
